document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".accordion__header").forEach((header) => {
        header.addEventListener("click", function () {
            const item = this.closest(".accordion__item");
            item.classList.toggle("accordion__item--active");
        });
    });
});
